import { db } from '@/database/db';
import Papa from 'papaparse';

export async function exportToCSV(sessionIds: string[]): Promise<void> {
  const sessions = await db.sessions.where('sessionId').anyOf(sessionIds).toArray();
  const opportunities = await db.opportunities.where('sessionId').anyOf(sessionIds).toArray();

  const rows = opportunities.map((opp) => {
    const session = sessions.find((s) => s.sessionId === opp.sessionId)!;

    return {
      session_id: session.sessionId,
      session_number: session.sessionNumber,
      facility: session.facilityName,
      service: session.serviceName,
      ward: session.wardName,
      session_date: session.sessionDate.toISOString().split('T')[0],
      observer: session.observerInitials,
      opportunity_number: opp.opportunityNumber,
      sequence_order: opp.sequenceOrder,
      hcw_category_code: opp.observedHCWCode,
      hcw_category_name: opp.observedHCWName,
      healthworker_identifier: opp.healthworkerIdentifier || 'star_1',
      healthworker_color: opp.healthworkerColor || 'red',
      indication_before_patient: opp.indications.includes('before_patient') ? 1 : 0,
      indication_before_aseptic: opp.indications.includes('before_aseptic') ? 1 : 0,
      indication_after_body_fluid: opp.indications.includes('after_body_fluid') ? 1 : 0,
      indication_after_patient: opp.indications.includes('after_patient') ? 1 : 0,
      indication_after_surroundings: opp.indications.includes('after_surroundings') ? 1 : 0,
      action_performed: opp.action.actionPerformed ? 1 : 0,
      action_type: opp.action.actionType,
      action_handrub: opp.action.handrubUsed ? 1 : 0,
      action_handwash: opp.action.handwashUsed ? 1 : 0,
      gloves_worn: opp.action.glovesWorn !== undefined ? (opp.action.glovesWorn ? 1 : 0) : '',
      timestamp: opp.timestamp.toISOString(),
    };
  });

  const csv = Papa.unparse(rows);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);

  link.setAttribute('href', url);
  const dateStr = new Date().toISOString().split('T')[0];
  const sessionCountSuffix = sessionIds.length > 1 ? `_${sessionIds.length}_sessions` : '';
  link.setAttribute('download', `cleanhands_export_${dateStr}${sessionCountSuffix}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
